export default function genConfig(configs, type) {
    return {
        ...configs[type],
        [type]: true
    };
};


// WEBPACK FOOTER //
// ./src/components/shared/genConfig.js